import React, { useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

import ChangeUserInfoForm from "./component/modifyProfilePage/changeUserInfoForm";
import ChangePwForm from "./component/modifyProfilePage/changePwForm";
import MembershipWithdrawal from "./component/modifyProfilePage/membershipWithdrawal";
import PageInfo from "../pageInfo";

import { Container } from "../styled/mypage";
import { TabMenu } from "./component/styled/dashboard";

const ModifyProfilePage = () => {
  const location = useLocation();
  const setting = useSelector((state) => state?.user?.setting);
  const tab = location?.state?.tab;
  const [tabIndex, setTabIndex] = useState(tab ? 2 : 0);

  // 탭 메뉴
  const tabs = ["계정정보변경", "비밀번호변경", "회원탈퇴"];

  function Components({ index }) {
    return <>{[<ChangeUserInfoForm />, <ChangePwForm />, <MembershipWithdrawal />][index]}</>;
  }

  return (
    <Container className={setting?.mode}>
      <PageInfo label="계정정보" />
      <TabMenu className={setting?.mode}>
        <ul>
          {tabs.map((item, idx) => (
            <li onClick={() => setTabIndex(idx)} className={idx === tabIndex ? "active" : ""}>
              {item}
            </li>
          ))}
        </ul>
      </TabMenu>
      {<Components index={tabIndex} />}
    </Container>
  );
};

export default ModifyProfilePage;
